export default function hex(value)
{

  return Math.floor(value).toString(16);

}
